import { cn } from "@babackapp/ui/lib/utils";
import { StepperBlockProps } from "../types";
import { Step } from "./step";

export interface StepData {
  title: string;
  status: "completed" | "active" | "pending";
}

interface StepperProps {
  steps: StepData[];
  theme: StepperBlockProps["theme"];
  section: StepperBlockProps["section"];
}

export function Stepper({ steps, theme, section }: StepperProps) {
  const lastStepIndex = steps.reduce((lastIndex, step, index) => {
    if (step.status === "active" || step.status === "completed") {
      return index;
    }
    return lastIndex;
  }, 0);

  const currentStep = steps[lastStepIndex];

  return (
    <div className="@container flex-1 flex flex-col w-full py-2 gap-4">
      <div className="flex w-full gap-4">
        {steps.map((step, stepIndex) => (
          <Step
            section={section}
            theme={theme}
            key={step.title}
            title={step.title}
            status={step.status}
            stepNumber={stepIndex + 1}
          />
        ))}
      </div>
      {/* Current step text - only visible on small containers */}
      {currentStep && (
        <div className="flex @sm:hidden" id="guillaume">
          <span className="font-semibold inline-flex gap-1 items-center">
            <img
              src={
                currentStep.status === "completed"
                  ? CHECK_ICON_SRC
                  : currentStep.status === "active"
                    ? LOADER_ICON_SRC
                    : PENDING_ICON_SRC
              }
              className={cn(
                "size-3",
                currentStep.status === "active" && "animate-spin",
              )}
              alt=""
            />
            {currentStep.title}
          </span>
        </div>
      )}
    </div>
  );
}

const CHECK_ICON_SRC =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyMGFjMjIiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtY2hlY2stYmlnLWljb24gbHVjaWRlLWNpcmNsZS1jaGVjay1iaWciPjxwYXRoIGQ9Ik0yMS44MDEgMTBBMTAgMTAgMCAxIDEgMTcgMy4zMzUiLz48cGF0aCBkPSJtOSAxMSAzIDNMMjIgNCIvPjwvc3ZnPg==";

const PENDING_ICON_SRC =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM5ZTllOWUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtaWNvbiBsdWNpZGUtY2lyY2xlIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjwvc3ZnPg==";

const LOADER_ICON_SRC =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMjg2MjEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1sb2FkZXItY2lyY2xlLWljb24gbHVjaWRlLWxvYWRlci1jaXJjbGUiPjxwYXRoIGQ9Ik0yMSAxMmE5IDkgMCAxIDEtNi4yMTktOC41NiIvPjwvc3ZnPg==";
